<template lang="pug">
div.slide-dialog(:class="{'slide-dialog--active': value}")
  div.slide-dialog__underlay(:class="{'slide-dialog__underlay--active': value}" )
  div.slide-dialog__container(:class="{'slide-dialog__container--active': value}")
    div.slide-dialog__header(@click="close")
      v-btn.slide-dialog__minimize-btn(color="primary")
        v-icon(left) mdi-chevron-down
        | Свернуть
    v-card.slide-dialog__content
      v-container.full-height(v-if="idInstruction" key="instruction" fluid).py-0
        v-row.full-height
          v-col.app-card.d-none.d-md-block.full-height(cols="12" md="4" style="overflow-x:auto;").grey.lighten-4
            v-text-field(
              v-model="name"
              placeholder="Название инструкции"
              outlined
              dense
              hide-details
              v-debounce="getAllInstructions"
              append-icon="mdi-magnify"
            )
            div.mt-5(v-if="loadingAll")
              pu-skeleton.d-block.mb-2(v-for="i in 5" :key="i" height="45px")
            v-list(color="transparent" v-else-if="instructions.length")
              v-list-item-group
                v-list-item.pl-2(
                  v-for="instruction in instructions"
                  :key="instruction.id"
                  @click="currentInstruction = instruction.id"
                  :class="{'primary lighten-1 white--text' : currentInstruction === instruction.id}"
                )
                  v-list-item-action.mr-2
                    v-icon(:color="currentInstruction === instruction.id ? 'white' : ''")
                     | {{ instruction.type === 1  ? 'mdi-video-outline' : 'mdi-text-box-outline' }}
                  v-list-item-title.text-wrap {{ instruction.name }}
            v-alert.mt-5(v-else type="info") Инструкций не найдено
          v-col.fill-height(cols="12" md="8" v-if="currentInstruction" style="overflow-x:auto;")
            .d-flex.justify-center(v-if="loading")
              v-progress-circular(indeterminate)
            .app-card(v-else)
              .d-flex.align-center.justify-space-between.mb-2
                h2 {{ instruction.name }}
                HtmlTOPdf(
                  v-if="instruction.content && instruction.type === 2"
                  :fileName="instruction.name"
                )
                  div.instruction(v-html="instruction.content")
                  template(#activator="{ generate, loading }")
                    v-tooltip(bottom)
                      template(v-slot:activator='{ on }')
                        v-btn(
                          fab
                          small
                          color="primary"
                          :loading="loading"
                          v-on='on'
                          @click="generate"
                        )
                          v-icon mdi-upload
                      span Скачать PDF

              embed-youtube(
                v-if="value && instruction.type === 1 && Object.keys(instruction).length"
                :src="instruction.url"
                :min-height="450"
                :stop="true"
              )
              div.instruction(ref="a" v-html="instruction.content" v-if="instruction.type === 2")
      slot(name="content")
</template>

<script>
import EmbedYoutube from '../../EmbedYoutube.vue';
import directoryService from '@/services/API/directories';
import { mapGetters } from 'vuex';
import VueHtml2pdf from 'vue-html2pdf';
import HtmlTOPdf from '@/components/HtmlTOPdf.vue';

export default {
  name: 'SlideDialog',
  components: { EmbedYoutube, VueHtml2pdf, HtmlTOPdf },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    idInstruction: { type: Number, required: false, default: null },
  },
  data() {
    return {
      loading: false,
      loadingAll: false,
      instruction: {},

      instructions: [],

      currentInstruction: null,

      name: '',

      opt: {
        margin: [1, 1, 1, 1],
        // filename: 'hee hee',
        // margin: 10,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 1, useCORS: true },
        // pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait',
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      userRoles: 'auth/getUserRoles',
      isAuthenticated: 'auth/isAuthenticated',
    }),
  },
  watch: {
    currentInstruction: {
      handler(val) {
        if (val) {
          this.loading = true;
          directoryService
            .showInctruction(this.currentInstruction)
            .then((response) => {
              this.instruction = response.data.data;
              this.loading = false;
            });
        }
      },
    },
    idInstruction: {
      immediate: true,
      handler(val) {
        if (val) {
          this.currentInstruction = val;
        }
      },
    },
    page() {
      this.getAllInstructions();
    },
    value(v) {
      if (v && !this.instructions.length) {
        this.getAllInstructions();
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
    },

    getAllInstructions() {
      const params = {
        'search[system_id]': this.$conf.isVcht ? 5 : 2,
        'search[role_name]': this.isAuthenticated
          ? this.userRoles.join(',')
          : 'guest',
        'search[name]': this.name,
        'per-page': -1,
      };
      this.loadingAll = true;
      this.$rHandler(directoryService.getInctructions(params), (response) => {
        this.instructions = response.data.data;
        this.loadingAll = false;
      });
    },

    generatePDF() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-dialog {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  transform: translateY(100%);
  backdrop-filter: blur(2px);
  z-index: 15;
  transition: all 0.3s;

  &--active {
    transition: none;
    transform: translateY(0);
  }
}
.slide-dialog__underlay {
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  background-color: #000;
  opacity: 0;
  transform: translateY(0);
  transition: none;

  &--active {
    transition: all 0.3s;
    opacity: 0.3;
    transform: translateY(0);
  }
}

.slide-dialog__container {
  height: 80%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  transform: translateY(100%);
  transition: all 0.3s;
  transition-delay: 0.3s;

  &--active {
    transition-delay: unset;
    transform: translateY(0);
  }
}

.slide-dialog__header {
  padding-top: 20px;
  text-align: center;
}

.slide-dialog__content {
  overflow-y: auto;
  flex: 1;
}

.instruction {
  ::v-deep img {
    max-width: 100%;
    height: auto !important;
    object-fit: cover !important;
  }
}

.slide-dialog__minimize-btn.v-btn {
  border-bottom-right-radius: unset!important;;
  border-bottom-left-radius: unset!important;
  padding: 0 2rem;
  opacity: 1;
}
</style>
